//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscLearn(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 3.35001L1 9.70001L12 16.05L17 13.16V16.46L12 19.35L7 16.46V15.47L5 14.32V17.54V17.61L12 21.65L19 17.61V12L21 10.85V19H23V9.70001L12 3.35001ZM12 13.74L5 9.70001L12 5.66001L19 9.70001L12 13.74Z" fill="currentColor" /></svg>;
}
export default IconMiscLearn;